import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { removeRatiosFromContractChangeGql } from '../AgreementsQueries';

export const useRemoveAgreementsRatio = (
    contractChangeId: number,
    checkedIds: number[],
    refreshAgreementsRatio: () => void,
    refreshFilters: () => void,
) => {
    const dispatch = useDispatch();

    const [
        removeRatioContractChangeData,
        removeRatioContractChangeStatus,
        removeRatioContractChangeError,
        removeRatioContractChangeRequest,
        removeRatioContractChangeSetData,
    ] = useRequest({
        requestId: 'removeRatiosFromContractChange',
        query: removeRatiosFromContractChangeGql,
        withEffect: false,
    });

    const handleRemoveRatioContractChange = useCallback(() => {
        dispatch(removeRatioContractChangeRequest({ contractChangeId, ratioIds: checkedIds }));
    }, [checkedIds, contractChangeId, dispatch, removeRatioContractChangeRequest]);

    useEffect(() => {
        if (
            removeRatioContractChangeStatus === RequestStatus.SUCCESS &&
            removeRatioContractChangeData?.uerRemoveRatiosFromContractChange?.result
        ) {
            refreshAgreementsRatio();
            refreshFilters();
        }
    }, [
        refreshAgreementsRatio,
        refreshFilters,
        removeRatioContractChangeData?.uerRemoveRatiosFromContractChange?.result,
        removeRatioContractChangeStatus,
    ]);

    return {
        removeRatioContractChangeData: removeRatioContractChangeData?.uerRemoveRatiosFromContractChange,
        removeRatioContractChangeStatus,
        removeRatioContractChangeError,
        removeRatioContractChangeSetData,
        handleRemoveRatioContractChange,
    };
};
